import api from '@utils/api';
import React, { useEffect, useState } from 'react';
import { Form } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import analytics from '@stone/utils/analytics';
import FormField from '@ui/formfield/FormField';
import ErrorBox from '@components/common/ErrorBox';
import useQueryStringBoolean from '@common/utils/useQueryStringBoolean';
import Button from '@stone/ui/button/Button';
import ModalDialog from '@stone/components/modal/ModalDialog';
import NewsletterErrorModal from '@stone/components/newsletter/NewsletterErrorModal';
import NewsletterForm from '@stone/components/newsletter/NewsletterForm';
import customEventBus from '@common/scripts/libs/eventBus';
const Newsletter = (props) => {
    const { t } = useTranslation();
    const [errors, setErrors] = useState([]);
    const [modalErrorMessage, setModalErrorMessage] = useState();
    const [submitSuccess, setSubmitSuccess] = useState(false);
    const [showSubModal, setShowSubModal] = useQueryStringBoolean('nldialog', false);
    const [email, setEmail] = useState('');
    useEffect(() => {
        customEventBus.on('newsletter:open', (data) => {
            onSubmit({ nlField: data.email });
        });
        return () => {
            customEventBus.off('newsletter:open', (data) => {
                onSubmit({ nlField: data.email });
            });
        };
    }, []);
    const validateEmail = (email) => {
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    };
    const onSubmit = async (values) => {
        setErrors([]);
        if (validateEmail(values.nlField)) {
            const isNewEmail = await api.checkNewsletterEmail(values.nlField);
            if (isNewEmail.success) {
                setEmail(values.nlField);
                setShowSubModal(true);
                //check if we are on monclernow listing
                // if (props.isMonclernowModule) {
                //   analytics.newsletterModuleContinue();
                // } else {
                //   analytics.footerSection(props.footerSectionTitle, t('button.continue'));
                // }
            }
            else {
                setModalErrorMessage({
                    title: t('newsletter.alreadyregisteredtitle'),
                    body: t('newsletter.alreadyregisteredtext'),
                    buttonLink: '/',
                    buttonText: t('newslettermodal.continue'),
                });
            }
        }
        else {
            setErrors([t('forgotpassword.invalidemail')]);
        }
    };
    // useEffect(() => {
    //   const bodyId = document.querySelector('body').id;
    //   if (!['cart-show', 'checkout-begin'].includes(bodyId) && window.innerWidth > window.mqObj.sm && !window.appmode) {
    //     let maincontent = document.getElementById('maincontent');
    //     let footer = document.querySelector('.footer') as HTMLElement;
    //     let header = document.querySelector('header') as HTMLElement;
    //     if (maincontent && footer && footer.offsetHeight <= window.innerHeight - header.offsetHeight) {
    //       maincontent.style.marginBottom = `${footer.clientHeight}px`;
    //     }
    //   }
    // }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement(Form, { onSubmit: onSubmit, render: ({ handleSubmit }) => (React.createElement("form", { onSubmit: handleSubmit },
                React.createElement("div", { className: "newsletter-container", "data-error": (errors === null || errors === void 0 ? void 0 : errors.length) > 0 ? true : false },
                    React.createElement(FormField, { dark: props.isDark, className: "form-control--outline", labelClassName: "form-group__label form-group__label--floating", name: "nlField", label: t('footer.email.address'), type: "email", autocomplete: "email", required: true, placeholder: t('footer.newsletter.placeholder') }),
                    React.createElement(ErrorBox, { errors: errors, className: "mt-20" }),
                    React.createElement(Button, { type: "submit", cls: ['button--secondary'], inverted: props.isDark }, t('button.continue'))))) }),
        React.createElement(NewsletterErrorModal, { isOpen: Boolean(modalErrorMessage === null || modalErrorMessage === void 0 ? void 0 : modalErrorMessage.title), modalErrorMessage: modalErrorMessage, onRequestClose: setModalErrorMessage }),
        React.createElement(ModalDialog, { className: "newsletter-modal newsletter-modal--subscription-modal lg-scrollable", isOpen: showSubModal, 
            // isOpen={true}
            contentLabel: "Newsletter subscription", onRequestClose: () => {
                // analytics.newsletterCloseModal();
                setShowSubModal(false);
            }, onAfterOpen: () => !submitSuccess && analytics.newsletter('start'), fullHeight: true, fullWidth: true },
            React.createElement("div", { className: "newsletter-modal__wrapper" }, submitSuccess ? (React.createElement(React.Fragment, null,
                React.createElement("h2", { className: "newsletter-modal__title modal__title", role: "alert" }, t('newslettermodal.successtitle')),
                React.createElement("p", { className: "newsletter-modal__description modal__description" },
                    React.createElement("span", { dangerouslySetInnerHTML: { __html: t('newslettermodal.successdescription') } })),
                React.createElement("div", { className: "modal__buttonrow" },
                    React.createElement("a", { href: window.homeurl, className: "button button--primary" },
                        React.createElement("span", null, t('newslettermodal.continue')))))) : (React.createElement(React.Fragment, null,
                React.createElement("h2", { className: "newsletter-modal__title modal__title" }, t('newslettermodal.title')),
                React.createElement("p", { className: "newsletter-modal__description modal__description" },
                    React.createElement("span", null, t('newslettermodal.description'))),
                React.createElement(NewsletterForm, { title: t('newslettermodal.detailstitle'), email: email, cookiepage: props.cookiepage, onSubmitSuccess: () => {
                        setSubmitSuccess(true);
                    } })))))));
};
export default Newsletter;
